import { Directive, Input, inject } from '@angular/core';
import { MatChipGrid } from '@angular/material/chips';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { FormControlState } from 'ngrx-forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ngrxFormControlState]',
  standalone: false,
})
export class CustomErrorStateMatcherDirective {

  #input = inject(MatInput, { host: true, optional: true });
  #select = inject(MatSelect, { host: true, optional: true });
  #chipList = inject(MatChipGrid, { host: true, optional: true });

  @Input() set ngrxFormControlState(state: FormControlState<any>) {

    const errorsAreShown = state.isInvalid && (state.isTouched || state.isSubmitted);

    if (this.#input) {
      this.#input.errorState = errorsAreShown;
      this.#input.stateChanges.next();
    }

    if (this.#select) {
      this.#select.errorState = errorsAreShown;
      this.#select.stateChanges.next();
    }

    if (this.#chipList) {
      this.#chipList.errorState = errorsAreShown;
      this.#chipList.stateChanges.next();
    }
  }

}
